<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title" style="padding-top:2.5em;"><a id="pagev">Contents</a></h1><a id="pagev">
<p> </p>
</a><p class="toc-entry0"><a id="pagev"></a><a href="#/006_Acnowlegment#ack" id="ack"><em>Acknowledgments</em></a></p>
<p class="toc-entry0"><a href="#/007_Abbreviations#list" id="list"><em>List of Abbreviations</em></a></p>
<p> </p>
<p class="toc-entry0"><a href="#/009_Introduction#intro" id="intro">Introduction: Journeys, Festivals, and the Making of National Pasts</a></p>
<p class="toc-entry0"><span href="#/010_Chapter1#ch1" id="ch1" title="Link target outside of Sample">1. Van Riebeeck’s Pasts</span></p>
<p class="toc-entry0"><span href="#/011_Chapter2#ch2" id="ch2" title="Link target outside of Sample">2. “We Build a Nation”: The Festival of Unity and Exclusion</span></p>
<p class="toc-entry0"><span href="#/012_Chapter3#ch3" id="ch3" title="Link target outside of Sample">3. Contesting Van Riebeeck’s Nation</span></p>
<p class="toc-entry0"><span href="#/013_Chapter4#ch4" id="ch4" title="Link target outside of Sample">4. “<em>’n Fees vir die Oog”</em> [A Festival/Feast for the Eye]: Looking in on the 1952 Jan Van Riebeeck Tercentenary Festival Fair</span></p>
<p class="toc-entry0"><span href="#/014_Chapter5#ch5" id="ch5" title="Link target outside of Sample">5. Local and National Pasts: The Journeys of the Mail Coach “Settlers” through the Eastern Cape</span></p>
<p class="toc-entry0"><span href="#/015_Chapter6#conl" id="conl" title="Link target outside of Sample">Conclusion: Post Van Riebeeck</span></p>
<p> </p>
<p class="toc-entry0"><span href="#/016_Note#notes" id="notes" title="Link target outside of Sample"><em>Notes</em></span></p>
<p class="toc-entry0"><span href="#/017_Bibliography#bio" id="bio" title="Link target outside of Sample"><em>Bibliography</em></span></p>
<p class="toc-entry0"><span href="#/018_Index#index" id="index" title="Link target outside of Sample"><em>Index</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005_Content.vue?28518ccc